import React, { useContext, useState, useReducer } from "react";
import { useQuery } from "react-query";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import ChooseProtocol from "./ChooseProtocol";
import PreviewSchedule from "./PreviewSchedule";
import PreviewSurveys from "./PreviewSurveys";
import * as api from "../../services";
import AppContext from "../../appContext";
import protocolReducer from "./protocolReducer";

function Protocol(props) {
  // local state
  const { open, handleClose } = props;
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const [protocol, protocolDispatch] = useReducer(protocolReducer, {
    clientId,
    protocolId: "",
    lastSaved: "",
    protocolLastSaved: "",
    changesJSON: JSON.stringify({}),
    projectId,
  });

  // server state
  // init protocol (set last changed client id)
  useQuery(
    ["poll", clientId, projectId, sessionId],
    () => api.poll({ id: clientId, projectId, sessionId, editingId: clientId }),
    {
      onSuccess: (data) => {
        if (data?.lock?.lastSaved) {
          protocolDispatch({
            type: "SET_LAST_SAVED",
            payload: data.lock.lastSaved,
          });
        }
      },
    }
  );

  // wizard
  const [step, setStep] = useState(0);
  const wizard = [
    {
      maxWidth: "sm",
      content: (props) => <ChooseProtocol {...props} />,
    },
    {
      maxWidth: "md",
      content: (props) => <PreviewSurveys {...props} />,
    },
    {
      maxWidth: "md",
      content: (props) => <PreviewSchedule {...props} />,
    },
  ];
  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={wizard[step].maxWidth}
    >
      <DialogContent sx={{ minHeight: 400 }}>
        {wizard[step].content({
          handleNext,
          handleBack,
          handleClose,
          protocol,
          protocolDispatch,
        })}
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
}

export default Protocol;
